import { createFileRoute } from "@tanstack/react-router";
import { OpportunitiesPage } from "../../../workspaces/work-atlas/pages/OpportunitiesPage";
import { stringParam } from "../../../lib/url-state";

type OpportunitiesSearch = { readonly campaign?: string };

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/opportunities")({
  validateSearch: (search: Record<string, unknown>): OpportunitiesSearch => ({
    campaign: stringParam(search.campaign),
  }),
  component: OpportunitiesRoute,
});

function OpportunitiesRoute() {
  const { campaign } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <OpportunitiesPage campaign={campaign}
    onCampaignChange={name => { void navigate({ search: { campaign: name } }); }} />;
}
